import i18n from '@/i18n';
import {
  resolveCatalogSection,
  type CatalogSection,
} from '@/i18n/catalogLookup';

/** Dot-safe lookup for API-driven entity labels under `catalog.*`. */
export function tCatalog(section: CatalogSection, name: string): string {
  return resolveCatalogSection(i18n, section, name);
}
